import da from '../JsonLang/da.json'
export const lang = { ...da }